var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenerateKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 12.0013C20.3333 16.6013 16.6 20.3346 12 20.3346C7.39996 20.3346 4.59163 15.7013 4.59163 15.7013M4.59163 15.7013H8.35829M4.59163 15.7013V19.868M3.66663 12.0013C3.66663 7.4013 7.36663 3.66797 12 3.66797C17.5583 3.66797 20.3333 8.3013 20.3333 8.3013M20.3333 8.3013V4.13464M20.3333 8.3013H16.6333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateKey);
export default __webpack_public_path__ + "static/media/generate-key.f24a466bbffe93cbae8801ad486fb664.svg";
export { ForwardRef as ReactComponent };